<template>
	<div>
		<headdv :headTitle="headTitle" :isBackShow="true" :goPath="goPatHead" :activeWebTitle = 'activeWebTitle'></headdv>
		<div style="height:80px;"></div>
		<div class="content_dv" :style="{height:(screenHeight-80-28)+'px'}">
			<div class="content_dv_dv">
				<headdv2 @tapAddFun="addManager" @SearchFun="SearchFun" @allDelFun="allDelFun"  @condition1="condition1" :headData="headData" :dataClassify="dataClassify" @condition12="condition12"></headdv2>
				<div class="content">
					<el-table :data="accountList" header-row-class-name="headrow" style="width: 100%" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55"></el-table-column>
						<!-- <el-table-column type="index" label="#"></el-table-column> -->
						<el-table-column prop="nct_number" label="章节序号"  min-width="100"></el-table-column>
						<el-table-column prop="nct_title" label="章节标题"  min-width="200" ></el-table-column>
						<el-table-column prop="n_title" label="小说标题" min-width="200"></el-table-column>
						<el-table-column prop="nct_status" label="状态"  min-width="100" :formatter="formatter_nct_status"></el-table-column>
						<el-table-column prop="nct_origin" label="来源" min-width="180"></el-table-column>
						<el-table-column prop="nct_content" label="章节内容" min-width="180" show-overflow-tooltip></el-table-column>
						<el-table-column prop="nct_addtime" label="添加时间" width="180" :formatter="formatter_time"></el-table-column>
						<el-table-column prop="nct_id" label="章节ID" width="80"></el-table-column>
						<el-table-column prop="n_id" label="小说ID" width="80"></el-table-column>
						<el-table-column label="操作"  width="100" fixed="right">
						<template slot-scope="scope">
							<el-button	class="edit"	size="small"	type="text"	icon="iconfont icon-zhongxinshuru"	@click="editTangChuan(scope.row)"	>编辑</el-button>
							<el-button size="small"	type="text"	icon="iconfont icon-qingchujiaose"	@click.native.prevent="handleDeleteClick(scope.row)"	>删除</el-button>
						</template>
						</el-table-column>
					</el-table>
				</div>
				
				<!--分页-->
            	<page :pageData="pageData" @changeSizeFun="handleSizeChange" @changeCurrentFun="handleCurrentChange"></page>
			</div>
		</div>
		<!-- 底部 -->
		<footerdv></footerdv>
		<!-- 编辑/添加 -->
		<el-dialog :visible.sync="dialogVisible" width="920px" class="dialog" :close-on-click-modal="false">
			<div class="dialog-title" slot="title">{{isEditOrAdd?'修改':'添加'}}</div>
			<!-- 内容区 start-->
			<el-form ref="staffForm" :rules="rules" :model="staffForm" label-width="100px">
				<el-form-item label="标题:" prop="nct_title">
					<el-input v-model="staffForm.nct_title" placeholder="请输入标题"></el-input>
				</el-form-item>
				<el-form-item label="章节序号:" rop="nct_number">
					<el-input v-model="staffForm.nct_number" placeholder=""></el-input>
				</el-form-item>
				<el-form-item label="来源:" rop="nct_origin">
					<el-input  v-model="staffForm.nct_origin" placeholder=""></el-input> 
				</el-form-item>
				<el-form-item label="章节内容:" prop="nct_content">
					<editor-bar v-model="staffForm.nct_content"  :isClear="isClear"  @change="change"></editor-bar> 
				</el-form-item>
			</el-form>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="sendRequest" type="danger">文件点击上传</el-button>   -->
				<el-button @click="resetForm('staffForm')">取 消</el-button>
				<el-button type="primary" @click="saveForm('staffForm')">保 存</el-button>
			</span>
		</el-dialog>

		<!-- 批量修改 -->
		<el-dialog :visible.sync="statusVisible" width="650px" class="dialog">
			<div class="dialog-title" slot="title">批量修改用户状态</div>
			<!-- 内容区 start-->
			<el-form   label-width="100px">
				<el-form-item label="用户状态：" prop="u_status">
					<el-switch v-model="u_status" inactive-text="否" active-text="是" :inactive-value="0" :active-value="1"></el-switch>
				</el-form-item>
			</el-form>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="statusVisible=false">取 消</el-button>
				<el-button type="primary" @click="updataStatus()">保 存</el-button>
			</span>
		</el-dialog>
		
		<!-- 删除 -->
		<el-dialog :visible.sync="delDate.status" width="400px" class="dialog">
			<div class="dialog-title" slot="title">删除</div>
			<!-- 内容区 start-->
			<span>确定删除?</span>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="delDate.status=false">取 消</el-button>
				<el-button type="primary" @click="allDeleteEvent">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			novel_id:'',
			// 新富文本编辑器
			isClear: false,
				editor: {
				info: "",
			},
			headData:{
				search_placeholder:'请输入章节标题',
				add:true,
				search:true,
				del:false,
				condition1:false,
				condition2:false,
				condition3:false,
				condition4:false,
				condition5:false,
				condition6:false,
				condition8:false,
				condition9:false,
				condition11:false,
				condition12:true,
				condition12_status:1,
			},
			screenHeight: document.documentElement.clientHeight ,// 屏幕高度
			activeWebTitle:'设置',
			//分页
			pageData: {
				pagecount: 1, //总页数  ,默认1
				pagesize: 10, //每页多少条  默认10
				pageindex: 1, //当前页  默认1
				count: 1,
			},
			u_reboot:0, //是否为机器用户 0否 1是
			u_status:0, //用户状态 0:正常 1:禁用
			multipleSelection: [],      //操作多选的数据---   左边勾选的框都会显示在这个数组中
			statusVisible:false,
			delarr: [], //存放删除的数据
			//删除弹窗
			delDate: {
				title: "删除账号",
				label: "删除数据不可恢复，确定删除？",
				status: false,
			},
			//分组id
			problemArrId_type: [],
			accountList: [], //列表数据
			checkedList: [], //选中的绑定值
			headTitle: "员工管理",
			goPatHead: "settings",
			dialogVisible: false,   //开启验证
			isEditOrAdd: false, //判断是添加还是编辑，true为编辑/false为添加
            //修改编辑的数据
			staffForm: {
				nct_id:'',
				n_id: "",
				nct_title: "",
				nct_number: 0,
				nct_origin: "",
				nct_content: "",
			},
			//验证规则
			rules: {
				nct_title: [{ required: true, message: "请输入章节标题", trigger: "blur" },],
				nct_number: [{ required: true, message: "请输入章节序号", trigger: "blur" },],
				nct_origin: [{ required: true, message: "请输入来源", trigger: "blur" },],
				nct_content: [{ required: true, message: "请输入章节内容", trigger: "blur" }],
			},
			//分类数据
			dataClassify:[],   
			fileList: [],               //app文件
			percentage:0,              //进度条
			percentageStatus:'准备上传',//上传状态
			nct_status:1,   //章节状态码
			searchData:{
				key:'', //搜索内容
				
			}
		};
	},
	created() {
		console.log(this.$route.query)
		this.novel_id = this.$route.query.id
		//this.getclasslist_arrid();
		this.getclasslist();
	},
	methods: {
		//删除封面
        handleRemove_filePic(file) {
            this.fileList = [];
        },
        //选取要上传的封面后 
        handlechange_filePic(file, fileList) {
            let value = fileList[0];
            this.fileList.push(value.raw);
            this.fileList = fileList;
        },
        //点击添加里更换封面的按钮事件
        sendRequest() {
			//先判断 ，如果这个变量为空，说明没有选择本地资源，弹窗提示先选择内容
            if (this.fileList.length == 0) {
                this.$message("文件不能为空，请选择要上传的文件"); 
                return false
            } 
			let _this = this
			let percentageNum = 0
			this.percentageStatus = '正在努力上传中。。'
			let percentageTime = setInterval(() => {
				if(percentageNum<99){
					percentageNum++
					this.percentage = percentageNum
				}else{
					clearInterval(percentageTime)
				}
			},100)
            //上传文件的参数  格式
            let fd = new FormData();
            fd.append("item", 'novel');                  //根据接口文档  填写的标识  比如 要上传图片：就是img   视频就是video  联系我们contact  这个得看借口文档
            fd.append("file", this.fileList[0].raw);      //从本地选择好的文件
            fd.append("time", this.common.time);
            fd.append("platform", this.common.platform);
            fd.append("version", this.common.version);          
            //定义好参数后，发送请求，将文件资源发送给服务器，成功后 会返回资源链接
            this.https(this.apiList.upload, fd).then(response => {
                if (response.data.code == this.common.code) {
					this.percentageStatus = '上传成功'
					clearInterval(percentageTime)
					this.percentage = 100
                    this.staffForm.n_cover = response.data.data[0].path
                    console.log(  this.staffForm.n_cover)
                    let path = response.data.data[0].path          //返回的资源链接
                    this.staffForm.n_cover = path         //将返回的资源链接  赋值给input 输入框，，显示出来
                    this.tc_element(response.data.msg,response.data.code,2,"添加文件")   //成功的提示
                    this.fileList = [];    //完成后 清空数据
                }
            })
        },
		change(val) {
		     console.log("val", val);
		     //this.tgmsg = val;  //这里将获取到的值  赋值给 对应得变量
	    },
		//跳转所有章节
		allChapter(item){
			console.log(item)
			this.$router.push({name:'chapter',query: {id:item.id,classid:item.classid}})
		},
		//批量修改状态  保存
		updataStatus(){
			let ids = ''
			const length = this.multipleSelection.length;
			for (let i = 0; i < length; i++) {
				if(ids == ''){
					ids = this.multipleSelection[i].u_id
				}else{
					ids = ids + ',' + this.multipleSelection[i].u_id
				}
			}
			let fromData = {
				u_id:ids,
				u_status:this.u_status,
			}
			this.https(this.apiList.batchUpdateUser, fromData).then(
				(response) => {
				if (response.data.code == this.common.code){
					this.getclasslist();
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "批量修改");
				}
				this.statusVisible = false; //隐藏提示框
				}
			);
		},
		//格式化内容--时间
		formatter_time(row, column, cellValue, index) {
			let time = this.gettime.format(cellValue*1000,3) 
			return time;
		},
		formatter_nct_status(row, column, cellValue, index){
			if(cellValue == 1){
				return '正常'
			}else{
				return '异常'
			}
		},
		//格式化内容--性别
		formatter_u_sex(row, column, cellValue, index) {
			if (cellValue == 1) {
					return "男";
			} else {
					return "女";
			}
		},
		//格式化内容--状态 0 下架 1 上架
		formatter_n_status(row, column, cellValue, index){
			if (cellValue == 1) {
					return "上架";
			} else {
					return "下架";
			}
		},
		//格式化内容--连载状态 0 连载中 1 已完结
		formatter_n_serial_status(row, column, cellValue, index){
			if (cellValue == 1) {
					return "已完结";
			} else {
					return "连载中";
			}
		},
		//格式化内容--部门		
		formatter_ar_id(row, column, cellValue, index) {
			for (let i = 0; i < this.problemArrId_type.length; i++) {
				if (cellValue == this.problemArrId_type[i].ar_id) {
					return this.problemArrId_type[i].ar_name;
				}
			}
		},

		
		//返回
		goBack() {
			this.$router.go(-1);
		},
		//获取分类数据
		getclasslist_arrid() {
			this.is_ok = false; //控制帅选请求 一个一个来
			let get = `?limit=${this.pageData.pagesize}&page=${this.pageData.pageindex}`;
			this.https(this.apiList.getNovelClassList + `${get}`).then((response) => {
				if (response.data.code == this.common.code) {
				this.dataClassify = response.data.data.rows; //列表数据
				console.log(this.dataClassify)
				}
			});
		},
		//获取小说列表数据
		getclasslist() {
			this.is_ok = false; //控制帅选请求 一个一个来
			let get = `?pagesize=${this.pageData.pagesize}\n`+ 
					  `&pageindex=${this.pageData.pageindex}\n`+
					  `&key=${this.searchData.key}\n`
			//let get = `?limit=${this.pageData.pagesize}&page=${this.pageData.pageindex}&nct_status=${this.nct_status}&n_id=${this.novel_id}`;
			this.https(this.apiList.getNovelChapterList + `${get}`).then((response) => {
				if (response.data.code == this.common.code) {
               		this.accountList = response.data.data.data; //列表数据
					this.pageData.pagecount = response.data.data.total_page; //总页数
					this.pageData.count = response.data.data.total; //总条数
				}
			});
		},
		// 点击添加按钮
		addManager() {
			for(let key in this.staffForm){
				if(key == 'n_serial_status' || key == 'n_status'){
					this.staffForm[key] = 0
				}else{
					this.staffForm[key] = ''
				}
			}
			this.dialogVisible = true;
			this.isEditOrAdd = false;
		},
		//添加--的确定
		createAccount() {
			let fromData = {}
			for(let key in this.staffForm){
				if(key !='nct_id' && key !='n_id'){
					fromData[key] = this.staffForm[key]
				}
			}	
			fromData.n_id = this.novel_id
			this.https(this.apiList.addNovelChapter, fromData).then(
				(response) => {
				if (response.data.code == this.common.code) {
					this.getclasslist();
					for(let key in this.staffForm){
						this.staffForm[key] = ''
					}
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "添加");
				}
				this.dialogVisible = false; //隐藏提示框
				}
			);
		},
		
		//点击编辑事件   显示修改弹窗
		editTangChuan(row) {
			this.dialogVisible = true;
			this.isEditOrAdd = true;
			for(let key in this.staffForm){
				this.staffForm[key] = row[key]
			}	
		},
		//编辑弹窗   确定按钮
		createAccount_bianji() {
			let fromData = {}
			for(let key in this.staffForm){
				fromData[key] = this.staffForm[key]
			}	
			this.https(this.apiList.updateNovelChapter,fromData).then((response) => {
				if (response.data.code == this.common.code) {
					this.getclasslist();
					//弹窗提示
					this.tc_element(	response.data.msg,	response.data.code,	2,	"编辑");
				}
				this.dialogVisible = false;
			});
		},
		//点击删除按钮  的点击事件
		handleDeleteClick(row) {
			this.delDate.status = true;
			const id = row.nct_id;
			this.delarr.push(id);
		},
		//点击批量删除按钮  的点击事件
		AllDeleteClick(row) {
			this.delDate.status = true;
			const length = this.multipleSelection.length;
			for (let i = 0; i < length; i++) {
				this.delarr.push(this.multipleSelection[i].nct_id);
			}
		},
		//点击删除弹窗的确定按钮
		allDeleteEvent() {
			let fromData = {
				nct_id : this.delarr[0],
			}
			this.https(this.apiList.deleteNovelChapter, fromData).then(
				(response) => {
				if (response.data.code == this.common.code) {
					if (this.accountList.length <= 1) {
					if (this.pageData.pageindex == 1) {
						this.pageData.pageindex = 1;
					} else {
						this.pageData.pageindex--;
					}
					}
					this.getclasslist();
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "删除数据");
				}
				this.delDate.status = false; //隐藏提示框
				this.delarr = [];
				}
			);
		},
		// 保存
		saveForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// 校验通过
					
					this.dialogVisible = false;
					if (this.isEditOrAdd) {
						//  编辑
						this.createAccount_bianji()
					} else {
						//  添加
						this.createAccount()
					}
				} else {
					//验证失败
					console.log("error submit!!");
					return false;
				}
			});
		},
		//编辑/添加--取消
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false;
		},
		//删除-取消
		deleteRow() {
			this.delDate.status = false;
		},
		

		//头部组件促发的方法
        //添加
        tapAddFun(){
            this.isShowAddForm = true
        },
        //搜索方法
        SearchFun(data){
            console.log(data)
        },
        //批量删除
        allDelFun(){
           console.log('del')
        },
        //条件筛选1
        condition1(){
			  this.statusVisible = true
            console.log('批量修改')
        },
        //条件筛选2
        condition2(){
            console.log('condition2')
        },
        //条件筛选3
        condition3(){
            console.log('condition3')
        },
        //条件筛选4
        condition4(){
            console.log('condition4')
        },
        //条件筛选5
        condition5(){
            console.log('condition5')
		},
		condition12(val){
			console.log(val)
			this.nct_status = val
			this.getclasslist()
		},
        //分页
			//pageSize 改变时会触发    每页条数
			handleSizeChange(val) {
				console.log(val)
				this.pageData.pagesize = val 
				this.getclasslist();
			},
			//currentPage 改变时会触发     当前页
			handleCurrentChange(val) {
				console.log(val)
				this.pageData.pageindex = val
				this.getclasslist();
			},
        //取消删除--子组件促发
        cancelDel(){
            this.delDate.status = false;
        },
        //确定删除--子组件促发
        determineDel(){
            //this.allDeleteEvent()
		  },
			//操作多选  --获取多选的内容s
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
		  
			//格式化内容--是否会员
			formatter_u_isvip(row, column, cellValue, index) {
					if (cellValue == 1) {
						return "是";
					} else {
						return "否";
					}
			},
			//格式化内容--是否为代理商
			formatter_u_is_agent(row, column, cellValue, index) {
					if (cellValue == 1) {
						return "是";
					} else {
						return "否";
					}
			},
			//格式化内容--是否会员
			formatter_u_status(row, column, cellValue, index) {
					if (cellValue == 1) {
						return "正常";
					} else {
						return "禁用";
					}
			},
	},
};
</script>
<style lang="scss" scoped>
::v-deep .el-textarea .el-textarea__inner {
	min-height: 100px!important;
}
::v-deep .el-textarea{
	width:760px;
}
::v-deep .el-progress {
    margin-top: 7px;
}
.percentageStatus{
	position:absolute;
	left:50%;
	top:50%;
	transform: translate(-50%,-50%);
	color:#ccc;
}
::v-deep .text {
    min-height: 150px;
}
// 表格样式
::v-deep .el-table {
  .headrow,
  .headrow th {
    background-color: #f1f4f5 !important;
  }
  th > .cell {
    color: #555555;
  }
  .cell {
    color: #aaaaaa;
    display: flex;
    // flex-direction: row;
    // align-items: center;
    // justify-content: center;
  }
  .el-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    color: #ec808d;
    &.edit {
      color: #4f7da4;
    }
    .iconfont {
      font-size: 14px;
      margin-right: 5px;
    }
  }
}
// 对话框
.dialog {
  .dialog-title {
    width: 100%;
    height: 40px;
    background: #4f7da4;
    line-height: 40px;
    color: #ffffff;
    padding-left: 18px;
    font-size: 14px;
    box-sizing: border-box;
  }
  // 对话框头部
  ::v-deep .el-dialog__header {
    padding: 0;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 7px;
    right: 10px;
    font-size: 24px;
    .el-dialog__close {
      color: #ffffff;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 30px !important;
  }
  // 底部按钮
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  ::v-deep .el-button {
    width: 128px;
    &.el-button--default {
      background: #f2f2f2;
      color: #aaaaaa;
      border: none;
    }
    &.el-button--primary {
      background: #4f7da4;
      border: none;
    }
    & + .el-button {
      margin-left: 25px;
    }
  }
}
</style>